import { Pipe, PipeTransform } from '@angular/core';
import { DropdownItem } from '../types/dropdown-item.iterface';

@Pipe({
  name: 'keyToValue'
})
export class KeyToValuePipe implements PipeTransform {

  transform(value: string, list: DropdownItem[]): any {
    return list.find(item => item.key === value)?.value.toString();
  }

}
